import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { User, Mail, Shield, Clock, LogOut } from 'lucide-react';
import Button from '../components/common/Button';

const SessionPage = () => {
    const { user, logout } = useAuth();

    const getRoleLabel = (role) => {
        switch (role?.toLowerCase()) {
            case 'admin': return 'Administrador';
            case 'user': return 'Usuario';
            case 'xd': return 'XD';
            default: return role;
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-8">
                {/* Header */}
                <div className="text-center mb-8">
                    <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <User className="h-10 w-10 text-blue-600" />
                    </div>
                    <h1 className="text-2xl font-bold text-gray-900">Sesión Activa</h1>
                    <p className="text-gray-500 text-sm mt-1">Información de tu sesión actual</p>
                </div>

                {/* Session Info */}
                <div className="space-y-4">
                    <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-xl">
                        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <User className="h-5 w-5 text-blue-600" />
                        </div>
                        <div>
                            <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">Nombre</p>
                            <p className="text-gray-900 font-semibold">{user?.full_name}</p>
                        </div>
                    </div>

                    <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-xl">
                        <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <Mail className="h-5 w-5 text-green-600" />
                        </div>
                        <div>
                            <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">Correo</p>
                            <p className="text-gray-900 font-semibold">{user?.email}</p>
                        </div>
                    </div>

                    <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-xl">
                        <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <Shield className="h-5 w-5 text-purple-600" />
                        </div>
                        <div>
                            <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">Rol</p>
                            <p className="text-gray-900 font-semibold">{getRoleLabel(user?.role)}</p>
                        </div>
                    </div>

                    <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-xl">
                        <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <Clock className="h-5 w-5 text-yellow-600" />
                        </div>
                        <div>
                            <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">Estado</p>
                            <div className="flex items-center space-x-2">
                                <span className="w-2 h-2 bg-green-500 rounded-full inline-block"></span>
                                <p className="text-gray-900 font-semibold">Activo</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Logout */}
                <div className="mt-8">
                    <Button
                        variant="outline"
                        onClick={logout}
                        className="w-full flex items-center justify-center space-x-2 text-red-600 border-red-300 hover:bg-red-50"
                    >
                        <LogOut className="h-4 w-4" />
                        <span>Cerrar Sesión</span>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SessionPage;
